import { fromJS } from 'immutable';

import { ApiBacklogClient, UserToken } from '../../../helper/HelperAuth'
import { GetBacklogClient } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, client_id,sender_id,phone_number) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiBacklogClient + 'backlog-list';
    if(page === undefined){
        page = 1;
    }
    let clients = client_id;
    if (client_id == null || client_id == undefined) {
        clients = "";
    }

    let senders = "";
    if (sender_id === undefined) {
        senders = "";
    }else{
        senders = sender_id;
    }

    if(phone_number == undefined){
        phone_number = ""
    }
    var query = {
        'client' : clients,
        'sender' : senders,
        'phone-number':phone_number,
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":"ASC",
    };
    var paramBody = {
        "data": query
    };
//debugger
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            // 'Authorization': 'token123',
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('clients');
        var items = [];
        data.map((item) => {
            const prefixData = item.get('prefix').toJS();
            var prefix = [];
            prefixData.map((item2) => {
                const key = Object.keys(item2)[0];
                if (item2[key].isactive===true) {
                    prefix.push({
                        'prefix': key,
                        'code': item2[key].$numberLong
                    });
                }
            });
            items.push({
                'client_name': item.get('client_name'),
                'client_id': item.get('client_id'),
                'wa_host': item.get('wa_host'),
                'webhook': item.get('webhook'),
                'message_webhook': item.get('message_webhook'),
                'user': item.get('user'),
                'api_version': item.get('api_version'),
                'ojk_rules': item.get('schedule').get('enable'),
                'start': item.get('schedule').get('start'),
                'stop': item.get('schedule').get('stop'),
                'phone_number_id': item.get('phone_number_id'),
                'is_converter': item.get('is_converter'),
                'rate_limits': item.get('rate_limits'),
                'concurrent': item.get('concurrent'),
                'prefix': prefix,
            });
        });

        var data2 = {
            'row-count': data.size,
            'page-size': 1,
            'page-count': 1,
            'order-by': 1,
            'page': 1,
            'order': 'ASC',
            'data': items
        }
    }

    dispatch({ type: GetBacklogClient, data: fromJS(data2) });
};